import { __ } from '@wordpress/i18n';
import {
    TextControl,
} from '@wordpress/components';
import * as Controls from '../../../controls';
const { IconPicker, ColorControl } = Controls;

const Hobbies = ({ item, index, itemIndex, handleChangeItemField, setAttributes, attributes }) => {
	const {
		hobbyIconColor,
		hobbyNameColor,
		style,
	} = attributes || {};
	return (
		<>
			<TextControl
				label={__('Hobby Name', 'cv-builder')}
				value={item.name || ''}
				onChange={(value) =>
					handleChangeItemField(value, index, itemIndex, 'name')
				}
			/>
			{item.icon !== undefined && (
				<IconPicker
					label={item.icon ? `${item.icon}` : 'Select Icon'}
					selectedIcon={item.icon}
					changeIcon={(value) => handleChangeItemField(value, index, itemIndex, 'icon')}
				/>
			)}
			{
				style !== 'style26' && style !== 'style27' && style !== 'style28' && (
					<>
					<ColorControl
						label={__(
						'Icon Color',
						'cv-builder'
						)}
						color={hobbyIconColor}
						colorName="hobbyIconColor"
						onChange={(colorObj) => setAttributes(colorObj)}
					/>
					<ColorControl
						label={__(
						'Name Color',
						'cv-builder'
						)}
						color={hobbyNameColor}
						colorName="hobbyNameColor"
						onChange={(colorObj) => setAttributes(colorObj)}
					/>
				</>
			)}
		</>
	);
};

export default Hobbies;
